<template>
  <v-data-table
    :headers="headers"
    :items="checklist"
    :loading="loading"
    :no-data-text = "$t('AddToTable')"
    loading-text=""
    :items-per-page-text="rowsPerPageText"
    :items-per-page-items="allRows ? allRows : rowsPerPageItems"
    :header-props="{ sortIcon }"
    :footer-props="{
      prevIcon: allRows ? null : prevIcon,
      nextIcon: allRows ? null : nextIcon
    }"
    class="elevation-2"
  >
    <template v-slot:item="props">
      <tr>
        <td class="text-xs-left">{{ props.item.label }}</td>
        <td class="text-xs-left">{{ props.item.type }}</td>
        <td class="text-xs-left">{{ props.item.required ? 'True' : 'False'}}</td>
        <td class="text-xs-left">{{ Number(props.item.index) }}</td>
        <td class="text-xs-left">{{ props.item.value ? props.item.value : 'Empty'}}</td>
        <td v-if="!editionDisabled">
          <app-datatable-action-buttons
            :user-can-edit="!props.item.value"
            @edit="$emit('editItem', props.item)"
            :user-can-delete="!props.item.value"
            @delete="$emit('removeItem', props.item)"
          />
        </td>
      </tr>
    </template>
    <template v-slot:pageText="props">
      {{ props.pageStart }} - {{ props.pageStop }} {{ $t("tables.Of") }}
      {{ props.itemsLength }}
    </template>

    <template v-slot:no-data>
      <div v-if="loading" />
    </template>
  </v-data-table>
</template>

<script>
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";

export default {
  name: "PhotoLabelTableCreate",

  mixins: [activitiesTasksDataMixin, managementDatatableMixin],

  components: { AppDatatableActionButtons },

  props: {
    checklist: {
      type: Array,
      required: true
    },

    editionDisabled: {
      type: Boolean,
      default: true
    },
    allRows: {
      type: Array
    }
  },

  computed: {
    headers() {
      return [
        {
          text: `${this.$i18n.tc("Label")}`,
          value: "label",
          width: "28%"
        },
        {
          text: `${this.$i18n.tc("Type")}`,
          value: "type",
          width: "15%"
        },
        {
          text: `${this.$i18n.tc("Required")}`,
          value: "required",
          width: "15%"
        },
        {
          text: `${this.$i18n.tc("Index")}`,
          value: "index",
          width: "12%"
        },
        {
          text: `${this.$i18n.tc("Value")}`,
          value: "value",
          width: "15%"
        },
        {
          text: "",
          value: "action",
          sortable: false,
          width: "15%"
        }
      ];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Photos/PhotoLabelTableCreate.vue